module.exports = __webpack_public_path__ + "c5d043e79dacf99c907132b79b0272e3.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/801.png
// module id = 1706
// module chunks = 2